/**
 * Copyright 2025 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

import {Component} from 'preact-compat';
import PropTypes from 'prop-types';
import userDataStore from '../../../../shared/userDataStore';
import config from '../../../../config';
import Select from './Select';
import {resolutions, experimentalResolutions} from '../data/Resolutions';

const resolutionOptions = config.enableExperimentalFeatures ? [...resolutions, ...experimentalResolutions] : resolutions;
const customResolution = Number(userDataStore.get(`${config.storeLocalStateKey}/PublisherGumResolution`, '0'));

if (customResolution) {
  const existingResolution = resolutions.find(resolution => resolution.value === customResolution);

  if (!existingResolution) {
    resolutions.push({
      name: `${customResolution}p`,
      value: customResolution,
      compatibleQualities: ['uhd', 'fhd', 'xhd', 'hd', 'sd', 'ld', 'vld', 'uld'],
      index: 0
    });
  }
}

const compatibleResolutions = resolutionOptions.filter(resolution => resolution.compatibleQualities.includes(config.publisher.quality)).sort((resolutionA, resolutionB) => resolutionA.index - resolutionB.index);

export class ResolutionSelect extends Component {
  componentDidMount() {
    if (!this.props.defaultValue) {
      this.props.changeGumResolution(compatibleResolutions[0].value);
    }
  }

  render() {
    const {defaultValue, changeGumResolution, disabled} = this.props;
    const options = compatibleResolutions.map(resolution => ({
      value: resolution.value,
      label: resolution.name
    }));

    return (
      <Select
        defaultValue={defaultValue}
        onChange={changeGumResolution}
        disabled={disabled}
        options={options}
      />
    );
  }
}

ResolutionSelect.propTypes = {
  defaultValue: PropTypes.string.isRequired,
  changeGumResolution: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired
};